var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9667 16.2605L33.7896 10.0792C29.5667 5.85004 27.4562 3.73962 25.1875 4.23962C22.9208 4.73962 21.8937 7.54587 19.8375 13.1563L18.4458 16.9542C17.8979 18.45 17.6229 19.198 17.1292 19.7771C16.9079 20.037 16.6561 20.2693 16.3792 20.4688C15.7625 20.9125 14.9958 21.123 13.4625 21.5459C10.0042 22.5 8.2729 22.9771 7.62082 24.1084C7.33875 24.5979 7.19206 25.1538 7.19582 25.7188C7.20415 27.025 8.4729 28.2938 11.0083 30.8334L13.9583 33.7834L4.63332 43.1167C4.34917 43.4179 4.1936 43.818 4.19963 44.2321C4.20567 44.6462 4.37284 45.0416 4.66565 45.3344C4.95847 45.6272 5.35387 45.7944 5.76793 45.8004C6.18199 45.8064 6.5821 45.6509 6.88332 45.3667L16.2062 36.0334L19.2604 39.0917C21.8146 41.6459 23.0917 42.925 24.4062 42.925C24.9583 42.925 25.5021 42.7834 25.9833 42.5084C27.125 41.8563 27.6042 40.1146 28.5646 36.6292C28.9854 35.098 29.1958 34.3334 29.6375 33.7146C29.8312 33.4459 30.0562 33.2 30.3083 32.9813C30.8812 32.4855 31.625 32.2063 33.1104 31.648L36.9521 30.2042C42.5021 28.1209 45.2771 27.0771 45.7646 24.8167C46.2542 22.5542 44.1604 20.4563 39.9667 16.2605Z",
    fill: "#5BB5E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.cda3d7598efb236a0f2195063607fe88.svg";
export { ForwardRef as ReactComponent };